import {isArray, mergeWith, uniqWith} from "lodash-es"
import {TAssociation} from "@ui/api/features"
import {LayerId} from "./"
import FeatureService from "./FeatureService"
import aggregation from "./Aggregation"

export interface IAssociation {
  addAssociations(associations?: TAssociation[]): void
  getAssociation(id: number): TAssociation
  selectAssociation(association_ids: number[]): void
  cancelAssociation(): void
}

class Association {
  associationLayers = [LayerId.ACHARE, LayerId.BOYLAT]
  associations: {[id: number]: TAssociation} = {}

  addAssociations(associations?: TAssociation[]): void {
    associations?.forEach(association => {
      if (association.id in this.associations) {
        this.associations[association.id] = mergeWith(
          this.associations[association.id],
          association,
          (objValue: any, srcValue: any) => {
            if (isArray(objValue) || isArray(srcValue)) {
              return uniqWith(
                [...(objValue || []), ...(srcValue || [])],
                (val1: any, val2: any) => {
                  return val1.id === val2.id
                }
              )
            }
            return objValue
          }
        )
      } else {
        this.associations[association.id] = association
      }
    })
  }

  getAssociation(id: number): TAssociation {
    return this.associations[id]
  }

  selectAssociation(association_ids: number[]): void {
    Object.values(this.associationLayers).forEach(layerId => {
      FeatureService.getLayer(layerId)?.getSource()?.getFeatures().forEach(f => {
        if (f.getProperties().association_ids?.some((asso_id: number) =>
          association_ids.includes(asso_id))) {
          f.setProperties({selected: true})
        }
      })
    })
    association_ids.forEach(asso_id => {
      const asso = this.getAssociation(asso_id)
      if (asso && asso.aggrs && asso.aggrs.length > 0) {
        aggregation.selectAggregation(asso.aggrs.map(({id}) => id))
      }
    })
  }

  cancelAssociation(): void {
    Object.values(this.associationLayers).forEach(layerId => {
      FeatureService.getLayer(layerId)?.getSource()?.getFeatures().forEach(f => {
        f.setProperties({selected: false})
      })
    })
    aggregation.cancelAggregation()
  }
}

export default new Association() as IAssociation
